module.exports = __webpack_public_path__ + "static/media/murga-naved.eaca09c3.jpg";